export default __webpack_public_path__ + "static/media/dff-selected.184667f4.svg";